import apiService from '@/services/apiService';

const actions = {
  getBigRegistrationButton({ commit }) {
    apiService.get(`paxel-big/registration-button`)
      .then((response) => {
        commit('getRegistrationButton', response.data.data);
      })
      .catch((error) => {
        console.log(error);
      });
  },
  postBigRegistrationButton({ commit }, payload) {
    return new Promise((resolve, reject) => {
      apiService.post('paxel-big/registration-button', payload)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  },


};

export default actions;
